export default __webpack_public_path__ + "static/media/car7.c2b92fca.jpg";